const keys = {
  INVALID_USER_TAX_CODE: 'common.validations.invalid_user_tax_code',
  INVALID_ZIPCODE: 'account.components.address.errors.invalid_zipcode',
  INVALID_DE_ADDRESS1: 'common.validations.invalid_de_address1',
  STRING_LENGTH: 'common.validations.string_length',
  REQUIRED: 'common.validations.required',
  MAX_LENGTH: 'common.validations.max_length',
  MIN_LENGTH: 'common.validations.min_length',
  NUMBER: 'common.validations.number',
  MIN_VALUE: 'common.validations.min_value',
  MAX_VALUE: 'common.validations.max_value',
  INVALID_EMAIL: 'common.validations.email',
  ALPHANUMERIC: 'common.validations.alphanumeric',
  NOT_IN_LIST: 'common.validations.not_in_list',
  PASSWORDS_MATCH: 'common.validations.passwords_match',
  INVALID_PASSPORT_NUMBER: 'common.validations.invalid_passport_number',
};

// Validation Error messages
export const INVALID_PHONE = 'common.validations.invalid_phone';
export const NOT_ONLY_WHITESPACE = 'common.validations.not_only_whitespace';

// Translation Keys
export const LABEL_ADDRESS_1 = 'common.forms.labels.address_1';

export const INVALID_ZIPCODE =
  global.translations && global.translations.messages[keys.INVALID_ZIPCODE];

export const LOGOUT = 'account.navigation.logout';

// Modal components messages
export const MODAL_FOOTER_CONFIRM_BUTTON = 'common.modals.confirm';
export const MODAL_FOOTER_CANCEL_BUTTON = 'common.modals.cancel';

// Onboarding Wizard component messages
export const ONBOARDING_WIZARD_INTRODUCTION =
  'common.onboarding_wizard.introduction';
export const ONBOARDING_WIZARD_START = 'common.onboarding_wizard.start';
export const ONBOARDING_WIZARD_PHONE_VERIFICATION_TITLE =
  'common.onboarding_wizard.phone_verification.title';
export const ONBOARDING_WIZARD_PHONE_VERIFICATION_SUMMARY =
  'common.onboarding_wizard.phone_verification.summary';
export const ONBOARDING_WIZARD_AGE_VERIFICATION_TITLE =
  'common.onboarding_wizard.age_verification.title';
export const ONBOARDING_WIZARD_AGE_VERIFICATION_SUMMARY =
  'common.onboarding_wizard.age_verification.summary';
export const ONBOARDING_WIZARD_AGE_VERIFICATION_DISCLAMER_1 =
  'common.onboarding_wizard.age_verification.disclamer_1';
export const ONBOARDING_WIZARD_AGE_VERIFICATION_DISCLAMER_2 =
  'common.onboarding_wizard.age_verification.disclamer_2';
export const ONBOARDING_WIZARD_LAST_STEP_TITLE =
  'common.onboarding_wizard.last_step.title';

// PhoneVerification component messages
export const PHONE_VERIFICATION_ERROR_SYSTEM_ERROR =
  'common.phone_verification.error.system_error';
export const PHONE_VERIFICATION_SEND_CODE_TITLE =
  'common.phone_verification.send_code.title';
export const PHONE_VERIFICATION_SEND_CODE_VIA =
  'common.phone_verification.send_code.via';
export const PHONE_VERIFICATION_SEND_CODE_VIA_SMS_LABEL =
  'common.phone_verification.send_code.via_sms_label';
export const PHONE_VERIFICATION_SEND_CODE_VIA_CALL_LABEL =
  'common.phone_verification.send_code.via_call_label';
export const PHONE_VERIFICATION_SEND_CODE_RATES_DISCLAIMER =
  'common.phone_verification.send_code.rates_disclaimer';
export const PHONE_VERIFICATION_SEND_CODE_BUTTON =
  'common.phone_verification.send_code.button';
export const PHONE_VERIFICATION_VERIFY_CODE_INPUT =
  'common.phone_verification.verify_code.code_input';
export const PHONE_VERIFICATION_VERIFY_CODE_TITLE =
  'common.phone_verification.verify_code.title';
export const PHONE_VERIFICATION_VERIFY_CODE_BUTTON =
  'common.phone_verification.verify_code.button';
export const PHONE_VERIFICATION_VERIFY_CODE_HELP_TEXT =
  'common.phone_verification.verify_code.help_text';
export const PHONE_VERIFICATION_VERIFY_CODE_HELP_LINK =
  'common.phone_verification.verify_code.help_link';
export const PHONE_VERIFICATION_HEADER = 'common.phone_verification.header';
export const PHONE_VERIFICATION_SELECT_PLACEHOLDER =
  'common.phone_verification.select_placeholder';
export const PHONE_VERIFICATION_INPUT_PLACEHOLDER =
  'age_verification.forms.phone_number.title';

// Validations
export const STRING_LENGTH =
  global.translations && global.translations.messages[keys.STRING_LENGTH];
export const MAX_LENGTH =
  global.translations && global.translations.messages[keys.MAX_LENGTH];
export const MIN_LENGTH =
  global.translations && global.translations.messages[keys.MIN_LENGTH];
export const NUMBER =
  global.translations && global.translations.messages[keys.NUMBER];
export const MIN_VALUE =
  global.translations && global.translations.messages[keys.MIN_VALUE];
export const MAX_VALUE =
  global.translations && global.translations.messages[keys.MAX_VALUE];
export const INVALID_EMAIL =
  global.translations && global.translations.messages[keys.INVALID_EMAIL];
export const ALPHANUMERIC =
  global.translations && global.translations.messages[keys.ALPHANUMERIC];
export const NOT_IN_LIST =
  global.translations && global.translations.messages[keys.NOT_IN_LIST];
export const PASSWORDS_MATCH =
  global.translations && global.translations.messages[keys.PASSWORDS_MATCH];
export const REQUIRED =
  global.translations && global.translations.messages[keys.REQUIRED];
export const INVALID_PASSPORT_NUMBER =
  global.translations &&
  global.translations.messages[keys.INVALID_PASSPORT_NUMBER];

// German address validation error
export const INVALID_DE_ADDRESS1 =
  global.translations && global.translations.messages[keys.INVALID_DE_ADDRESS1];

export const INVALID_USER_TAX_CODE =
  global.translations &&
  global.translations.messages[keys.INVALID_USER_TAX_CODE];
